// extracted by mini-css-extract-plugin
export default {"account_subscription_card_body":"fY","account_subscription_card_img":"gY","account_subscription_card_lower_section":"hY","account_subscription_card_category":"iY","account_subscription_card_title":"jY","account_subscription_card_price_section":"kY","account_subscription_card_servings":"lY","account_subscription_card_prices":"mY","account_subscription_card_price":"nY","account_subscription_card_price_actual":"oY"};
    if(module.hot) {
      // 1714442371298
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  